// Tediye Fişi / Tahsilat Makbuzu penceresi kullanım rehberi (iki belge türü tek rehberde). Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.paymentReceipt';

export const accountPaymentReceiptGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Tediye fişi ve tahsilat makbuzu'),
  intro: t(`${G}.intro`, 'Bu pencere, cariye ait bir ödeme veya tahsilat işlemini resmi olarak belgeleyen finansal kaydı gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Belge türü'),
    body: t(`${G}.regions.body`, 'Belge bilgileri'),
    footer: t(`${G}.regions.footer`, 'Yazdır'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi belgeye bakıyorsunuz?'),
      text: t(`${G}.s1.text`, 'Başlık belge türünü söyler. Cariye para ödediyseniz belge TEDİYE FİŞİ olur ve kırmızı renkle gösterilir; cariden para aldıysanız TAHSİLAT MAKBUZU olur ve yeşil renkle gösterilir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tediye fişi: cariye yapılan ödemeyi kayda geçirir. Muhasebe, iç kontrol ve denetimde ödemenin gerçekten yapıldığını kanıtlayan temel belgelerdendir.'),
        t(`${G}.s1.tip2`, 'Tahsilat makbuzu: cariden alınan tahsilatı kayda geçirir. Muhasebe, mutabakat ve denetimde işlemin kanıtı olarak kullanılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Belgede neler yer alır?'),
      text: t(`${G}.s2.text`, 'Belge numarası, cari bilgileri, ödeme bilgileri ve öne çıkan tutar kutusu ("Ödenen Tutar" ya da "Tahsil Edilen Tutar") sırayla gösterilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Belge numarası ve işlem tarihi'),
        t(`${G}.s2.tip2`, 'Cari hesap adı ve işlem açıklaması'),
        t(`${G}.s2.tip3`, 'Ödeme yöntemi, para birimi ve işlem tutarı'),
        t(`${G}.s2.tip4`, 'Kasa veya banka hesabı kullanıldıysa o hesabın bilgisi'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Yazdırın ve saklayın'),
      text: t(`${G}.s3.text`, '"Yazdır" belgeyi baskıya hazır açar; kâğıda ya da PDF\'e alabilirsiniz. Çıktıda imza alanları bulunur: tediye fişinde "Ödeyen / Teslim Alan", tahsilat makbuzunda "Tahsil Eden / Teslim Eden".'),
      tips: [
        t(`${G}.s3.tip1`, 'Çıktıyı muhasebe dosyalamada, cari mutabakatta ve iç denetimde doğrudan kullanabilirsiniz.'),
      ],
    },
  ],
});
